import { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { okaidia } from "react-syntax-highlighter/dist/esm/styles/prism";
import { apiURL } from "../api";

export default function Task({ task, getTasksList, index }) {
  okaidia['pre[class*="language-"]'].background = "#212529";

  const [isHovered, setIsHovered] = useState(false);
  const { userData } = useContext(UserContext);

  const taskLinkStyle = {
    textDecoration: "none",
    color: "black",
  };

  const taskStyle = {
    backgroundColor: isHovered ? "rgb(242, 239, 235)" : "transparent",
    transition: "background-color 0.5s ease-in",
  };

  const navigate = useNavigate();

  const navigateToCreateSolution = () => {
    navigate(`/tasks/create-solution/${task.uuid}`);
  };

  const navigateToUpdateTask = () => {
    navigate(`/tasks/update/${task.uuid}`);
  };

  const navigateToUpdateSolutions = () => {
    navigate(`/tasks/update-solutions/${task.uuid}`);
  };

  const handleConfirmDelete = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        method: "task.delete",
        params: {
          uuid: task.uuid,
        },
      }),
    };

    if (task?.uuid) {
      fetch(apiURL + "/admin", requestOptions)
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            throw new Error(response.error.message);
          }
        })
        .catch((error) => {
          console.error("Failed to delete task:", error);
        })
        .finally(() => {
          getTasksList();
        });
    }
  };

  return (
    <div className="card mb-2">
      <div className="card-header">
        <div className="row fw-bold px-2">{`${index}. ${task.title}`}</div>
      </div>
      <div className="card-body" style={taskStyle}>
        <div
          className="fw-normal"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Link
            to={`/tasks/task-with-solutions/${task.uuid}`}
            className="mb-1"
            style={taskLinkStyle}
          >
            <div dangerouslySetInnerHTML={{ __html: task.text }} />
          </Link>
        </div>
        {task.code && (
          <div>
            <SyntaxHighlighter language={task.codeLanguage} style={okaidia}>
              {task.code}
            </SyntaxHighlighter>
          </div>
        )}
        <div>{task.optionalText}</div>
      </div>
      <div className="card-footer py-1">
        <div className="row">
          <div className="col-lg-2 col-sm-3 col-xs-4 fw-lighter">
            Складність: {task.complexity}
          </div>
          <div className="col-lg-2 col-sm-3 col-xs-4 fw-lighter">
            Відповідей: {task.solutionsCount}
          </div>
        </div>
      </div>
      {userData && (
        <div className="card-footer p-1">
          <div className="row">
            <div className="col">
              <button
                type="button"
                className="btn btn-sm btn-primary text-nowrap m-1"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Add solution to the task"
                data-bs-target="#addSolutionToTask"
                onClick={() => {
                  navigateToCreateSolution();
                }}
              >
                <i className="bi bi-cloud-plus"></i>
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary text-nowrap m-1"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Update task solutions"
                data-bs-target="#updateTaskSolutions"
                onClick={() => {
                  navigateToUpdateSolutions();
                }}
              >
                <i className="bi bi-pencil-fill"></i>
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success text-nowrap m-1"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Update task"
                data-bs-target="#updateTask"
                onClick={() => {
                  navigateToUpdateTask();
                }}
              >
                <i className="bi bi-pencil-fill"></i>
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger text-nowrap m-1"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Delete the task"
                data-bs-target="#deleteTask"
                onClick={() => {
                  handleConfirmDelete();
                }}
              >
                <i className="bi bi-trash-fill"></i>
              </button>
            </div>
            <div className="col fw-lighter my-auto">
              Order Number: {task.orderNumber}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
